import { Component, OnInit } from '@angular/core';
import { HxPagedListDirective } from 'hx-components';
import { DictionaryModel, HxDictionaryService, HxUiLabelPipe, PagedList, toRouterQueryParams } from 'hx-services';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { takeUntil } from 'rxjs/operators';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { NzPageHeaderComponent, NzPageHeaderExtraDirective, NzPageHeaderSubtitleDirective, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzButtonComponent, NzButtonGroupComponent } from 'ng-zorro-antd/button';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzCollapseComponent, NzCollapsePanelComponent } from 'ng-zorro-antd/collapse';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { FormsModule } from '@angular/forms';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzThAddOnComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { NgFor } from '@angular/common';
import Timeout = NodeJS.Timeout;

@Component({
    selector: 'hc-dictionary-list',
    templateUrl: './dictionary-list.component.html',
    styleUrls: ['./dictionary-list.component.less'],
  imports: [TranslocoDirective, NzAffixComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzPageHeaderSubtitleDirective, NzPageHeaderExtraDirective, NzButtonComponent, RouterLink, NzIconDirective, NzCollapseComponent, NzCollapsePanelComponent, NzRowDirective, NzColDirective, NzInputDirective, FormsModule, NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzThAddOnComponent, NzTbodyComponent, NgFor, NzButtonGroupComponent, HxUiLabelPipe, TranslocoPipe]
})
export class DictionaryListComponent extends HxPagedListDirective<DictionaryModel> implements OnInit {

  params: { query?: string } = {};
  private timeoutId?: Timeout;

  constructor(
    override router: Router,
    override aRoute: ActivatedRoute,
    protected notification: NzNotificationService,
    private tr: TranslocoService,
    private dictionaryService: HxDictionaryService,
  ) {
    super(router, aRoute);
    this.limit = 20;
  }

  ngOnInit(): void {
    this.aRoute.queryParamMap.pipe(takeUntil(this.$destroyed))
      .subscribe(paramMap => {
        this.params.query = paramMap.get('query') ?? undefined;
        super.load(paramMap);
      });
  }

  applyFilters(delay?: number) {
    const navigateFn = () => this.router.navigate([], {
      relativeTo: this.aRoute,
      queryParams: toRouterQueryParams(this.params),
    });

    if (delay) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => navigateFn(), delay);
    } else {
      navigateFn();
    }
  }

  protected loadList(): Promise<PagedList<DictionaryModel>> {
    return this.dictionaryService.getDictionaryList({
      query: this.params.query,
      page: this.page,
      limit: this.limit,
    });
  }
}
